import script from "./SurpriseGift.vue?vue&type=script&setup=true&lang=js"
export * from "./SurpriseGift.vue?vue&type=script&setup=true&lang=js"

import "./SurpriseGift.vue?vue&type=style&index=0&id=d082ed52&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d082ed52"]])

export default __exports__